// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"127":"69ea5fec","511":"81f6cf2c","783":"81f6cf2c"}[chunkId] + ".chunk.css";
};